import { getSphericalCoordsFromPositionTarget } from './getSphericalCoordsFromPositionTarget';
import { cameraPositionToCanvasRatio, canvasRatioToZoom } from './math3d';

const realMod = (a, n) => (((a % n) + n ) % n);

const toTemplateAngleRanges = (verticalAngleDegIn, horizontalAngleDegIn) =>
{
  const verticalAngleDegIn0To360 = realMod(verticalAngleDegIn, 360);
  const horizontalAngleDegIn0To360 = realMod(horizontalAngleDegIn, 360);

  let verticalAngleDeg = verticalAngleDegIn0To360;
  let horizontalAngleDeg = horizontalAngleDegIn0To360;

  if (verticalAngleDegIn0To360 <  90) {
    // Do nothing
  }
  else if (verticalAngleDegIn0To360 < 180) {
    verticalAngleDeg = 180 - verticalAngleDeg;
    horizontalAngleDeg = realMod(180 + horizontalAngleDeg, 360);
  }
  else if (verticalAngleDegIn0To360 < 270) {
    // 270 vertical === -90
    // 180 === 0
    verticalAngleDeg = 180 - verticalAngleDeg;
    horizontalAngleDeg = realMod(180 + horizontalAngleDeg, 360);
  } else {
    verticalAngleDeg = verticalAngleDeg - 360;
  }

  return { verticalAngleDeg, horizontalAngleDeg };
}

export const getCameraZoomVerticalHorizontal = (camera, cameraTargetPositionV3, modelRoot) => {
  const {verticalAngleDeg, horizontalAngleDeg} = getSphericalCoordsFromPositionTarget(camera.position, cameraTargetPositionV3);
  const ratio = cameraPositionToCanvasRatio({
    aspect: camera.aspect,
    root: modelRoot,
    cameraPositionV3: camera.position,
    cameraTargetPositionV3,
    vFovDeg: camera.fov,
  });
  const zoom = canvasRatioToZoom(ratio);
  const templateAngles = toTemplateAngleRanges(verticalAngleDeg, horizontalAngleDeg);

  return {zoom, ...templateAngles};
}